module.exports = __webpack_public_path__ + "static/img/france.78e9f99.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/france.png
// module id = PZ7g
// module chunks = 1